import Plausible from 'plausible-tracker';


import config from '../../../config';


const {analytics} = config;
let plausible;
if (analytics.isEnabled) {

    plausible = Plausible({
        apiHost: analytics.apiHost,
        domain: analytics.domain,
        hashMode: false,
        trackLocalhost: config.environment.isDevelopment
    });

} else {

    // no-op
    plausible = {
        enableAutoPageviews: () => {},
        trackEvent: () => {}
    };
}

export default plausible;
